import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
const Button = ({ className, to, children, as, linkStyle, active, toolTipTitle, ...props }) => {
	const Tag = as;

	return (
		<>
			<Tooltip title={toolTipTitle}>
				{Tag === 'a' ? (
					<Link
						to={to}
						className={`btn ${active ? 'active' : ''} ${linkStyle ? 'btn-link' : ''} ${className ? className : ''}`}
					>
						{children}
					</Link>
				) : (
					<button className={`btn ${active ? 'active' : ''} ${linkStyle ? 'btn-link' : ''}  ${className}`} {...props}>
						{children}
					</button>
				)}
			</Tooltip>
		</>
	);
};

Button.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	to: PropTypes.string,
	as: PropTypes.string,
	linkStyle: PropTypes.bool,
	active: PropTypes.bool
};
export default Button;
